import * as Q from 'q';
import * as $ from 'jquery';
import * as globalConfig from 'globalConfig';

// Models
import { CountryResponseModel } from 'Content/ts/Models/Shared/AddressModels';

export module CountryService {
    export function GetCountries(): Q.Promise<CountryResponseModel[]> {
        return Q($.ajax({
            url: globalConfig.Urls.Account.Profile.GetCountries,
            method: "GET",
            dataType: "JSON"
        }));
    }
}